import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/plugins/toasted'
import 'plyr/dist/plyr.css'
import '@/plugins/vue-auth-image'
import VueTheMask from 'vue-the-mask'

// import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

store.dispatch('App/info').then(() => {
  Vue.use(VueTheMask)
  Vue.config.productionTip = false

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})
